import type {PropositionsModel} from "@/serviceWorker/workerComponents/Models/PropositionsModel";

export function processTermPropositions(terms: PropositionsModel[]) {
    if(terms) {
        for (let term of terms) {
            term.rp_arrival_moment = window.moment(term.arrival,'YYYY-MM-DD');
            term.rp_departure_moment = window.moment(term.departure,'YYYY-MM-DD');
            term.nights = term.rp_departure_moment.diff(term.rp_arrival_moment, 'day');
        }
    }
}